document.addEventListener("DOMContentLoaded", function() { 
    try {
        console.log('Account content loaded');
        document.getElementById('ageverify').addEventListener('click', function () {
          console.log('Account ageverify clicked');
            document.querySelector('.showFraspy').style.display = 'block';
            document.getElementById('modal-background-first').style.display = 'block';
            document.getElementById('modal-content-first').style.display = 'block';
            document.getElementById('fraspyTitle').style.display = 'none';
            document.getElementById('fraspyDescription').style.display = 'none';
        });

        document.getElementById('fraspyModalHide').addEventListener('click', function () {
            document.getElementById('modal-background-first').style.display = 'none';
            document.getElementById('modal-content-first').style.display = 'none';
        });
    } catch (e) {}
});

if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", function () {
        try {
            if (productsWithAgeCheck && !customerIsLoggedIn) {
                var locationpath = window.location.href.replace("/cart", "");
                document.querySelector("#fraspy-CheckOut").setAttribute("href", "/account/login?checkout_url=" + locationpath + "/checkouts/c/");
                if (window.localStorage.cartToken) {
                    var cartToken = window.localStorage.cartToken.replace(/"/g, "");
                    document.querySelector("#fraspy-CheckOut").setAttribute("href", "/account/login?checkout_url=" + locationpath + "/checkouts/c/" + cartToken);
                } else if (getCookieTlpxx("cart")) {
                    var cartToken = getCookieTlpxx("cart");
                    document.querySelector("#fraspy-CheckOut").setAttribute("href", "/account/login?checkout_url=" + locationpath + "/checkouts/c/" + cartToken);
                    console.log("5 " + cartToken);
                }
            }
        } catch (e) {
          console.log(e);
        }
    });
}

if (!customerIsLoggedIn && window.location.pathname.indexOf("account/register") < 1 && window.location.pathname.indexOf("account/login") < 1 && window.location.pathname.indexOf("cart") < 1) {
    var fraspy_return_url = getCookieTlpxx("fraspy_return_url");
    if (fraspy_return_url != "") {
        //$("body").hide();
        setCookieTlpxx("first_name", "", 0);
        setCookieTlpxx("last_name", "", 0);
        setCookieTlpxx("note_street", "", 0);
        setCookieTlpxx("note_zipcode", "", 0);
        setCookieTlpxx("note_city", "", 0);
        setCookieTlpxx("note_country", "", 0);
        setCookieTlpxx("note_birthday", "", 0);
        setCookieTlpxx("emailname", "", 0);
        //self.location.href = "./checkout";
    }
    setCookieTlpxx("fraspy_return_url", "", 0);
} else if (!customerIsLoggedIn && window.location.pathname.indexOf("account/register") < 1 && window.location.pathname.indexOf("account/login") < 1 && window.location.pathname.indexOf("cart") < 1 && window.location.pathname.indexOf("challenge") < 1) {
    setCookieTlpxx("fraspy_return_url", "", 0);
}

function setCookieTlpxx(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookieTlpxx(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
